export { default } from './Shortcuts'

export * from './Shortcuts.styles'
